<template>
  <v-col cols="12" md="4" class="pa-4 pt-5 pb-5" v-if="hasData">
    <router-link :to="link"><v-img :src="image" height="340"></v-img></router-link>
    <div class="mt-4">
      <h2 class="pretopia-head-font mb-2">{{ title }}</h2>
      <span class="subtitle-1 pretopia-lighten-text" v-html="subtitle"></span>
      <span class="subtitle-1"><router-link :to="link">{{ $t('common.readMore')}}</router-link></span>
    </div>
  </v-col>
</template>

<script>
import { isSwedishLocale } from '../../services/locale.service';

export default {
  props: {
    data: {},
  },

  computed: {
    hasData() {
      return this.data && this.data.newsimages.length > 0 && this.data.slug;
    },
    image() {
      return '/storage/news/' + this.data.id + '/' + this.data.newsimages[0]['thumb_name'];
    },
    title() {
      return this.data.title;
    },
    subtitle() {
      return this.data.subtitle;
    },
    link() {
      if (isSwedishLocale()) {
        return '/news/' + this.data.slug;
      }
      return '/news/' + this.data.slug_eng;
    },
  },
};
</script>
